<template>
  <div class="row server_group">
    <div class="server_group">
      <div class="server_group_header">
        <button
          class="btn btn-info"
          @click="addNew"
        >
          <i class="mdi mdi-plus-circle-outline" />{{ translate('group.create') }}
        </button>
      </div>
      <div class="row">
        <server-group-item
          v-for="(item, key) in groups_servers"
          :key="key"
          :group="item"
          @del_group="delete_group"
          @update_servers_group="update_servers_group"
        />
      </div>
    </div>
  </div>
</template>
<script>

import ServerGroupItem from './GroupItem'

export default {
  name: 'ServerGroup',
  components: {
    ServerGroupItem
  },
  data () {
    return {
      group: []
    }
  },
  props: {
    groups_servers: Array
  },
  mounted () {

  },
  methods: {
    addNew () {
      this.$http.v1.addNewGroupServer(() => {
        this.global_notify('info', this.translate('server.group_created'))
        this.update_servers_group()
      })
    },
    delete_group (id) {
      this.$http.v1.deleteServerGroup({id: id}, () => {
        this.global_notify('info', this.translate('server.delete.group_deleted'))
        this.update_servers_group()
      })
    },
    update_servers_group(){
      this.$emit('update_servers_group')
    }
  }

}
</script>
